import { ActionTree } from "vuex";
import {
    LOGOUT,
    LOGIN,
    SET_PERMISSION,
} from "./mutations-types";
import { IUserState } from "./state";
import { router } from "@/router";
import { authService, TelemetryService, apiClient, dflScopes } from "@/services";
import { IPermission } from "@/models";

export const actions: ActionTree<IUserState, any> = {

    async login(context): Promise<boolean> {
        const account = authService.getActiveAccount();
        let loggedIn = !(!account);
        if (!account) {
            loggedIn = await authService.login();
        }
        context.commit(LOGIN, account);
        return loggedIn;
    },

    async getAccessToken(context): Promise<string> {
        return await authService.getAccessToken(dflScopes);
    },

    async getPermission(context): Promise<any> {
        const response = await apiClient.get<IPermission>(`/groupusers/permission`);
        context.commit(SET_PERMISSION, response.data);
    },

    logout(context): void {
        authService.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
        context.commit(LOGOUT);
        router.push("/");
    },
};
